import { TrendingUp, TrendingDown, SearchSlashIcon, Lightbulb, FileSearch, ShieldAlert } from 'lucide-react'
import { DashboardStats } from '../../services/dashboardApi'

interface HomeStatsProps {
  data: DashboardStats
}

const HomeStats = ({ data }: HomeStatsProps) => {
  const stats = [
    {
      title: 'Projects',
      value: data.projects.total.toString(),
      variation: data.projects.growthPercentage,
      icon: FileSearch,
      color: 'text-primary-600 dark:text-primary-500'
    },
    {
      title: 'Scans',
      value: data.scans.total.toString(),
      variation: data.scans.growthPercentage,
      icon: SearchSlashIcon,
      color: 'text-primary-700 dark:text-primary-400'
    },
    {
      title: 'Assets',
      value: data.assets.total.toString(),
      variation: data.assets.growthPercentage,
      icon: Lightbulb,
      color: 'text-primary-600 dark:text-primary-500'
    },
    {
      title: 'Vulnerabilities',
      value: data.vulnerabilities.total.toString(),
      variation: data.vulnerabilities.growthPercentage,
      icon: ShieldAlert,
      color: 'text-primary-700 dark:text-primary-400'
    }
  ]

  const formatVariation = (variation: number) => {
    const isPositive = variation > 0
    const icon = isPositive ? TrendingUp : TrendingDown
    const color = isPositive ? 'text-green-600' : 'text-red-600'
    
    return (
      <div className={`flex items-center text-sm ${color}`}>
        {icon === TrendingUp ? (
          <TrendingUp className="h-4 w-4 mr-1" />
        ) : (
          <TrendingDown className="h-4 w-4 mr-1" />
        )}
        {Math.abs(variation)}%
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {stats.map((stat, index) => {
        const Icon = stat.icon
        return (
          <div key={index} className="bg-white dark:bg-gray-800 shadow rounded-lg p-6">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <Icon className={`h-8 w-8 ${stat.color}`} />
              </div>
              <div className="ml-4 flex-1">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400 truncate">
                  {stat.title}
                </p>
                <p className="text-2xl font-semibold text-gray-900 dark:text-white">
                  {stat.value}
                </p>
              </div>
            </div>
            {stat.variation !== 0 && (
              <div className="mt-4">
                {formatVariation(stat.variation)}
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                  from previous week
                </p>
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default HomeStats
